import {
  Box,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import { CARD_SX, SECTION_ICON_BOX_SX } from './accountOverview.utils';

export default function AccountOverviewSecurityCard({ navigate }) {
  return (
    <Box sx={{ ...CARD_SX, p: { xs: 2.75, md: 3 } }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        justifyContent="space-between"
        gap={2}
      >
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Box sx={SECTION_ICON_BOX_SX}>
            <LockOutlined sx={{ fontSize: 22 }} />
          </Box>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: '#0f172a',
                letterSpacing: '-0.01em',
                lineHeight: 1.2,
              }}
            >
              Segurança da conta
            </Typography>
            <Typography variant="body2" sx={{ color: '#64748b' }}>
              Atualize sua senha periodicamente para manter o acesso seguro.
            </Typography>
          </Box>
        </Stack>
        <Button
          variant="outlined"
          onClick={() => navigate('/alterar-senha')}
          sx={{
            alignSelf: { xs: 'stretch', sm: 'auto' },
            borderRadius: '12px',
            textTransform: 'none',
            fontWeight: 600,
            px: 2.5,
            py: 1,
            borderColor: 'rgba(8,145,178,0.32)',
            color: '#0891b2',
            '&:hover': {
              borderColor: '#0891b2',
              background: 'rgba(8,145,178,0.06)',
            },
          }}
        >
          Alterar senha
        </Button>
      </Stack>
    </Box>
  );
}
